import { login, getAgentUserInfo } from "@/api/login";
import { Message } from "element-ui";
import {
  getToken,
  setToken,
  removeToken,
  setMenus,
  setUser,
  setMenusCheckKey,
  setLogionUserInfo,
} from "@/utils/auth";
import md5 from "js-md5";
import { constantRouterMap } from "@/router";
import Layout from "@/views/layout/Layout.vue";
import {
  GeneralAgentAuthority,
  AgentPermissions,
} from "@/router/dynamic-router";
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";

/**
 * 递归生成子菜单
 */
function createChildren(RouterMap, routerArr) {
  RouterMap.filter((item) => {
    if (item.type === "MENU") {
      const itemRoute = {
        meta: { title: item.name, icon: item.icon ? item.icon.trim() : null },
        name: item.id + "" || "",
        path: (item.path && item.path.trim()) || "",
        component: () => import("@/views" + item.componentPath),
      };
      if (item.children && item.children.length) {
        const childrenRouterArr = [];
        createChildren(item.children, childrenRouterArr);
        itemRoute.children = childrenRouterArr;
      }
      routerArr.push(itemRoute);
    }
  });
}

function filterAsyncRouter(asyncRouterMap) {
  const routerArr = [];
  asyncRouterMap.filter((route) => {
    if (route.parentId === 0) {
      let newRoute = {};
      // 多级
      if (route.children && route.children.length) {
        newRoute = {
          path: "",
          alwaysShow: true,
          component: Layout,
          meta: {
            icon: route.icon.trim(),
            title: route.name,
          },
          name: route.name,
        };
        const routerArr = [];
        createChildren(route.children, routerArr);
        newRoute.children = routerArr;
      } else {
        // 单级
        newRoute = {
          path: "",
          component: Layout,
          name: "",
          children: [
            {
              path: route.path,
              name: route.name,
              meta: { title: route.name, icon: route.icon },
              component: () => import("@/views" + route.componentPath),
            },
          ],
        };
      }
      routerArr.push(newRoute);
    }
  });
  return routerArr;
}

const user = {
  state: {
    token: getToken(),
    username: "",
    avatar: "",
    roles: [],
    permissions: [],
    menus: [], // 菜单
    routers: [],
    addRouters: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_LOGINUSERINFO: (state, loginUserInfo) => {
      state.loginUserInfo = loginUserInfo;
    },
    SET_NAME: (state, username) => {
      state.username = username;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus;
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        const params = {
          mobile: userInfo.username.trim(),
          password: md5(userInfo.password),
          // captchaKey: userInfo.captchaKey,
          // captchaCode: userInfo.captchaCode
        };
        login(params)
          .then((response) => {
            // response.bizcode === 101 && response.errcode === 109
            // response.bizcode === 101 && response.errcode === 109 账号或者密码错误
            if (
              (response.bizcode === 101 && response.errcode === 109) ||
              (response.bizcode === 201 && response.errcode === 202)
            ) {
              resolve(-2);
            } else {
              const data = response.data;
              setToken(data.token);
              commit("SET_TOKEN", data.token);
              commit("SET_MENUS", data.menus);
              console.log("动态路由", data);
              setMenus([...AgentPermissions]);
              setMenusCheckKey("true");
              const user = {
                id: data.userId,
                name: data.name,
              };
              setUser(user);
              // 获取用户信息
              getAgentUserInfo({})
                .then((response) => {
                  console.log(
                    "app登录----33333",
                    response.data,
                    response.data?.isAgentLogin
                  );
                  // =3 代理商  =4 代理商管理员 =5 燕姐代理
                  if (response.data?.agentState) {
                    Message({
                      message: "代理考核未通过，不享受合伙人权益",
                      type: "error",
                      duration: 2000
                    });
                  }

                   if (
                    response.data?.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT
                  ) {
                    setMenus([...GeneralAgentAuthority]);
                    setMenusCheckKey("true");
                  }

                  if (
                    response.data?.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT
                  ) {
                    setMenus([...GeneralAgentAuthority]);
                    setMenusCheckKey("true");
                  }

                  // 燕姐代理
                  if (response.data?.teamLogo === 0) {
                    //  燕姐--所有权限都不显示代理商管理菜单
                    let filteredMenus = GeneralAgentAuthority.filter(item => item.name !== "代理商管理" && item.name !== "下级管理");
                  
                    // referrerAgent = 3 燕姐下代理合伙人
                    if (response.data?.referrerAgent === 3) {
                      filteredMenus = filteredMenus.filter(item => item.name !== "合伙人管理" && item.name !== "代理列表");
                    }

                    setMenus([...filteredMenus]);
                    setMenusCheckKey("true");
                  }

                  // 黄丽
                  if (response.data?.teamLogo === 1) {
                    //  黄丽--所有权限都不显示代理商管理菜单
                    let filteredMenus = GeneralAgentAuthority.filter(item => item.name !== "代理列表" && item.name !== "合伙人管理");
                    setMenus([...filteredMenus]);
                    setMenusCheckKey("true");
                  }

                  setLogionUserInfo(response.data);
                  resolve("ok");
                })
                .catch((error) => {
                  reject(error);
                });
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // app 登录
    appLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        console.log("app登录----122233", data.token);
        setToken(data.token);
        commit("SET_TOKEN", data.token);
        commit("SET_MENUS", data.menus);
        // setMenus([...AgentPermissions]);
        setMenusCheckKey("true");
        const user = {
          id: data.userId,
          name: data.name,
        };
        setUser(user);
        // 获取用户信息
        getAgentUserInfo({}).then((response) => {
           if (response.data?.agentState) {
             Message({
               message: "代理考核未通过，不享受合伙人权益",
               type: "error",
               duration: 2000
             });
           }
          setLogionUserInfo(response.data);
          // commit("SET_LOGINUSERINFO", loginUserInfo);
          console.log(
            "app登录----",
            response.data,
            response.data?.isAgentLogin
          );
          if (response.data?.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN) {
            setMenus([{}]);
            setMenusCheckKey("true");
          }
          if (response.data?.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT) {
            setMenus([...GeneralAgentAuthority]);
            setMenusCheckKey("true");
          }
          // 燕姐代理
          if (response.data?.teamLogo === 0) {
            //  燕姐--所有权限都不显示代理商管理菜单
            let filteredMenus = GeneralAgentAuthority.filter(item => item.name !== "代理商管理" && item.name !== "下级管理");

            // referrerAgent = 3 燕姐下代理合伙人
            if (response.data?.referrerAgent === 3) {
              filteredMenus = filteredMenus.filter(item => item.name !== "合伙人管理" && item.name !== "代理列表");
            }
          
            setMenus([...filteredMenus]);
            setMenusCheckKey("true");
          }

          // 黄丽
          if (response.data?.teamLogo === 1) {
            //  黄丽--所有权限都不显示代理商管理菜单
            let filteredMenus = GeneralAgentAuthority.filter(item => item.name !== "代理列表" && item.name !== "合伙人管理");
            setMenus([...filteredMenus]);
            setMenusCheckKey("true");
          }

          resolve("ok");
        });
      });
    },

    // 获取用户信息
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const { accessedRouters } = data;
        const accessedRoutersSum = filterAsyncRouter(accessedRouters);
        commit("SET_ROUTERS", accessedRoutersSum);
        resolve({ code: "ok", data: accessedRoutersSum });
      });
    },

    // 登出
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_LOGINUSERINFO", {});
        commit("SET_MENUS", []);
        removeToken();
        resolve();
      });
    },
  },
};

export default user;
